import { FiltersMap } from '@wix/bex-core';
import { useToolbarCollectionSyncProps } from '../ToolbarCollection/useToolbarCollectionSyncProps';
import { TableFoldersState } from '../../state';
import { TableFoldersColumn } from './TableFolders.types';
import { CustomColumnsElement } from '../assertComponentType';
import { MultiCollectionBulkActionToolbarRenderProps } from '../BulkAction';
import { useColumnsSyncProps } from '../../hooks/useColumnsSyncProps';

export interface UseTableFoldersSyncPropsParams<
  T1,
  F1 extends FiltersMap,
  T2,
  F2 extends FiltersMap,
> {
  state: TableFoldersState<T1, F1, T2, F2>;
  customColumns?: CustomColumnsElement | null;
  columns: TableFoldersColumn<T1, T2>[];
  bulkActionToolbar?: MultiCollectionBulkActionToolbarRenderProps;
  dragAndDrop?: any;
}

export function useTableFoldersSyncProps<
  T1,
  F1 extends FiltersMap,
  T2,
  F2 extends FiltersMap,
>(props: UseTableFoldersSyncPropsParams<T1, F1, T2, F2>) {
  const { state, customColumns, columns } = props;

  const toolbar = state.toolbar;

  useToolbarCollectionSyncProps({
    ...props,
    state: toolbar,
    isUsingDragAndDrop: !!props.dragAndDrop,
    isUsingBulkActionsToolbar: !!props.bulkActionToolbar,
    isUsingHorizontalScroll: true,
    isUsingFolders: true,
    isUsingTableVirtualization: true,
  });

  useColumnsSyncProps({
    toolbar,
    customColumns,
    columns,
  });

  return state;
}
